export default __webpack_public_path__ + "static/media/add-to-home.5add666c.png";